"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StepTracker;

var _react = _interopRequireDefault(require("react"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _Check = _interopRequireDefault(require("@decisiv/iconix/lib/components/Check"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _schema = _interopRequireDefault(require("./schema"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function StepTracker(_ref) {
  var _ref$activeStep = _ref.activeStep,
      activeStep = _ref$activeStep === void 0 ? 0 : _ref$activeStep,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps;
  return _react.default.createElement(_styles.StepTrackerContainer, null, steps.map(function (title, index) {
    var isActive = index + 1 === activeStep;
    var isCompleted = activeStep > index + 1;
    var isNextActive = index + 2 === activeStep;
    var isNextCompleted = activeStep > index + 2;
    var labelShade = isCompleted || isActive ? 0 : 1;
    return _react.default.createElement(_styles.StepWrapper, {
      key: (0, _uniqueId.default)("step-".concat(index))
    }, _react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, _react.default.createElement(_styles.StepSeparator, {
      active: isActive,
      completed: isCompleted,
      hide: index === 0
    }), _react.default.createElement(_styles.StepNumber, {
      active: isActive,
      completed: isCompleted
    }, isCompleted ? _react.default.createElement(_Check.default, {
      size: "small"
    }) : index + 1), _react.default.createElement(_styles.StepSeparator, {
      active: isNextActive,
      completed: isNextCompleted,
      hide: index === steps.length - 1
    })), _react.default.createElement(_styles.StepTitleContainer, null, _react.default.createElement(_styles.StepTitle, {
      shade: labelShade
    }, title)));
  }));
}

StepTracker.propTypes = _schema.default.propTypes;